import React, { Component } from 'react'
import {
    Link,
    Redirect
} from 'react-router-dom'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import ConfirmButton from "../../common/button/confirmbutton.component.jsx"

class LabelEditForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            id: '',
            title: '',
            type: 'tag',
            description: '',
            deleteButton: '',
        }

        this.submitLabel = this.submitLabel.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.deleteLabel = this.deleteLabel.bind(this)
    }

    componentDidMount() {
        const label = this.props.label
        if (label && label.id) {
            const deleteButton = <ConfirmButton identifier={label.attributes.title} onClick={this.deleteLabel} className="btn btn-danger">
                <FormattedMessage
                    id="label.form.edit.delete_btn"
                    defaultMessage="Delete label"
                />
            </ConfirmButton>
            this.setState({
                id: label.id,
                description: label.attributes.description,
                type: label.attributes.type,
                title: label.attributes.title,
                deleteButton: deleteButton,
            })
        }

    }

    deleteLabel(event) {
        const label = this.props.label
        AppContext.getApiClient().delete('/labels/' + label.id).then((response) => {
            let formStatus = ''
            if (!response.error) {
                formStatus = <Redirect
                    to={{
                        pathname: '/labels/listing'
                    }}
                />
            }
            this.setState({ formStatus: formStatus })
        })

        event.preventDefault()
    }

    saveLabel() {
        const label = this.props.label
        if (label && label.id) {
            let updates = {}
            const allowedFields = [
                "description",
                "title",
                "type",
            ]
            for (let i = 0; i < allowedFields.length; i++) {
                let field = allowedFields[i]
                if (label.attributes[field] != this.state[field]) {
                    updates[field] = this.state[field]
                }
            }
            return AppContext.getApiClient().patch('/labels/' + label.id, updates)
        } else {
            return AppContext.getApiClient().post('/labels', {
                "description": this.state.description,
                "title": this.state.title,
                "type": this.state.type,
            })
        }
    }

    submitLabel(event) {
        this.saveLabel().then((response) => {
            let formStatus = ''
            if (!response.error) {
                formStatus = <Redirect
                    to={{
                        pathname: '/labels/listing'
                    }}
                />
            }
            this.setState({ formStatus: formStatus })
        })

        event.preventDefault()
    }

    handleFormChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    render() {
        const messages = defineMessages({
            "label.form.edit.description_placeholder": {
                id: 'label.form.edit.description_placeholder',
                defaultMessage: 'Description of the label',
            },
            "label.form.edit.title_placeholder": {
                id: 'label.form.edit.title_placeholder',
                defaultMessage: 'Title of the label',
            },
            "tag_option": {
                id: 'label.form.edit.tag_option',
                defaultMessage: 'Tag',
            },
            "customer_tag_option": {
                id: 'label.form.edit.customer_tag_option',
                defaultMessage: 'Customer Tag',
            },
            "manufacturer_option": {
                id: 'label.form.edit.manufacturer_option',
                defaultMessage: 'Manufacturer',
            },
            "customer_type_option": {
                id: 'label.form.edit.customer_type_option',
                defaultMessage: 'Customer type',
            },
            "label.form.edit.save_btn": {
                id: 'label.form.edit.save_btn',
                defaultMessage: 'Save label',
            }
        })

        return (
            <form onSubmit={this.submitLabel}>
                <div className="row ui-has-modules">
                    <div className="col-12 ui-module">
                        <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="labelTitle">
                                <FormattedMessage
                                    id="label.form.edit.title_label"
                                    defaultMessage="Title"
                                />
                            </label>
                            <div className="col-10">
                                <input
                                    name="title"
                                    value={this.state.title}
                                    onChange={this.handleFormChange}
                                    id="titleDescription"
                                    type="text"
                                    className="form-control"
                                    placeholder={this.props.intl.formatMessage(messages['label.form.edit.title_placeholder'])}
                                />
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="label.form.edit.title_description"
                                        defaultMessage="Describe the label in a few words"
                                    />
                                </small>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="type">
                                <FormattedMessage
                                    id="label.form.edit.type_label"
                                    defaultMessage="Type"
                                />
                            </label>
                            <div className="col-10">
                                <select
                                    name="type"
                                    id="type"
                                    value={this.state.type}
                                    onChange={this.handleFormChange}
                                    className="form-control"
                                >
                                    <option value={'customer-tag'}>{this.props.intl.formatMessage(messages['customer_tag_option'])}</option>
                                    <option value={'tag'}>{this.props.intl.formatMessage(messages['tag_option'])}</option>
                                    <option value={'manufacturer'}>{this.props.intl.formatMessage(messages['manufacturer_option'])}</option>
                                    <option value={'customer-type'}>{this.props.intl.formatMessage(messages['customer_type_option'])}</option>
                                </select>
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="label.form.edit.type_description"
                                        defaultMessage="Type of label"
                                    />
                                </small>
                            </div>
                        </div>
                        <div className="form-group row">
                            <label className="col-2 col-form-label text-align-right" htmlFor="labelDescription">
                                <FormattedMessage
                                    id="label.form.edit.description_label"
                                    defaultMessage="Description"
                                />
                            </label>
                            <div className="col-10">
                                <textarea
                                    name="description"
                                    value={this.state.description}
                                    onChange={this.handleFormChange}
                                    id="labelDescription"
                                    className="form-control"
                                    placeholder={this.props.intl.formatMessage(messages['label.form.edit.description_placeholder'])}
                                />
                                <small className="form-text text-muted">
                                    <FormattedMessage
                                        id="label.form.edit.description_description"
                                        defaultMessage="Describe the label in a sentence"
                                    />
                                </small>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        {this.state.formStatus}
                    </div>
                    <div className="col-12 ui-module">
                        <div className="row">
                            <div className="col-6">
                                {this.state.deleteButton}
                            </div>
                            <div className="col-6 text-align-right">
                                <Link to="/labels/listing" className="btn btn-light">
                                    <FormattedMessage
                                        id="label.form.edit.cancel_btn"
                                        defaultMessage="Cancel"
                                    />
                                </Link>
                                &nbsp;
                                &nbsp;
                                <input type="submit" value={this.props.intl.formatMessage(messages['label.form.edit.save_btn'])} className="btn btn-primary" />
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default injectIntl(LabelEditForm)


// WEBPACK FOOTER //
// ./src/label/form/edit.component.jsx